<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconBreakoutRooms_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M1 4.4A1.4 1.4 0 0 1 2.4 3h11.2A1.4 1.4 0 0 1 15 4.4v7.7a1.4 1.4 0 0 1-1.4 1.4H2.4A1.4 1.4 0 0 1 1 12.1V4.4Zm2.1.7h4.2v2.8H3.1V5.1Zm4.2 3.5H3.1v2.8h4.2V8.6Zm1.4-3.5h4.2v2.8H8.7V5.1Zm4.2 3.5H8.7v2.8h4.2V8.6Z"
        clip-rule="evenodd"
    />
</svg>
